define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var config = require('config');
    var Class = require('Class');
    var $ = require('j');
    var Backbone = require('backbone');
    var util = require('utils');
    var logger = require('util/logger.util');

    require('widgets/animation.widget');

    var ANIMATION_CONFIG_TOKEN = 'animationConfig';

    var _animationConfig = {};
    var _animatedClasses = [];
    var _animatedElsSelector = '';

    var CIRCULAR_EFFECT_EXCLUDED_TAGS = [
        'area', 'base', 'br', 'col', 'command', 'embed',
        'hr', 'img', 'input', 'keygen', 'link', 'meta',
        'param', 'source', 'track', 'wbr'
    ];

    var ANIMATION_EFFECT_FILTERS = {
        'circularEffect': function(el) {
            var tagName = el.tagName.toLowerCase();
            if (CIRCULAR_EFFECT_EXCLUDED_TAGS.includes(tagName)) {
                logger.warn('Element of type "' + tagName + '" is not supported for animation type "circularEffect"');
                return false;
            }
            return true;
        }
    };

    // todo:
    // There are two main types of entities:
    // 1. Animation Targets - what admin turns on/off in CMS
    // 2. Animation Effects - actual effects that can be applied to some elements (`animation.widget` plugins)
    // To couple this together, we will use 3rd entity type - `Animation Target Class` or `Animation Target Selector`.
    // Relations:
    // Each Animation Target must have a collection of Animation Effects
    // Each Animation Target must have a collection of Animation Target Selectors
    // Each Animation Target must have a `Target Identifier Class Name`, which should be appended to element to
    //   identify animation target. It should be used to apply different styles to animation elements.

    // So, eventually, rewrite _parseConfig() method and `_configTemplate` to make all that more clear and flexible.
    // Also, final implementation should not query DOM more than once or performance may suffer.
    // var animationTargets = []; // from CMS settings
    // var animationEffects = []; // from animation.widget

    // HACK We do not use :not() construct to avoid multiple DOM queries on each update to increase performance
    var _animationsExclusionClasses = {
        'info-list__row': ['fn-accordion', 'fn-multiview-bonus']
    };

    module.exports = Class.create({

        _configTemplate: {
            animationEnabled: false,
            animationsMap: {
                // button
                'btn': ['circularEffect'],
                'popup-modal__button': ['circularEffect'],

                // accordion
                'fn-accordion': ['accordionEffect'],

                // gamesinfo nav item
                'gamesinfo__nav-item': ['circularEffect'],

                // menu slider
                'menu__navigation': ['slideLineMenu'],

                // list item (language list, expanded list, menu list, game list)
                'language-list__point': ['circularEffect'],
                'gamesinfo__list-row': ['circularEffect'],
                'info-list__row': ['circularEffect'],
                'info-list__header': ['circularEffect'],
                'slide-menu__point__name': ['circularEffect'],
                'slide-menu__list__header': ['circularEffect']
            },
            gamesinfoComingUp: false,
            gamesinfoRearrange: false
        },

        initialize: function() {
            this._parseConfig();

            if (!_animationConfig.animationEnabled) {
                return;
            }

            this._patchJBone();

            $('body').on('animation', this.attachAnimation.bind(this));
        },

        _parseConfig: function() {
            _animationConfig = util.deepExtend({}, this._configTemplate, config.get(ANIMATION_CONFIG_TOKEN));
            var resultMap = _animationConfig.animationsMap;

            if (!_animationConfig.navBarHover) {
                delete resultMap['menu__navigation']; // eslint-disable-line dot-notation
            }

            if (!_animationConfig.buttonPress) {
                delete resultMap['btn']; // eslint-disable-line dot-notation
                delete resultMap['popup-modal__button'];
                delete resultMap['gamesinfo__nav-item'];
            }

            if (!_animationConfig.listItemPress) {
                delete resultMap['language-list__point'];
                delete resultMap['gamesinfo__list-row'];
                delete resultMap['info-list__row'];
                delete resultMap['info-list__header'];
                delete resultMap['slide-menu__point__name'];
                delete resultMap['slide-menu__list__header'];
            }

            if (!_animationConfig.accordionExpandCollapse) {
                delete resultMap['fn-accordion'];
            }

            _animatedClasses = Object.keys(_animationConfig.animationsMap);
            _animatedElsSelector = _animatedClasses
                .map(function(cls) {
                    return '.' + cls;
                })
                .join(',');
        },

        _patchJBone: function() {
            var patchAnimations = function(originalFnName) {
                var originalFn = $.fn[originalFnName];
                var preservedFnName = 'original' + originalFnName[0].toUpperCase() + originalFnName.substring(1);
                $.fn[preservedFnName] = originalFn;

                $.fn[originalFnName] = function() {
                    var result = originalFn.apply(this, arguments);
                    var event = {type: 'animation', data: this};
                    $('body').trigger($.Event(event));
                    return result;
                };
            };

            var fnNames = [
              'append',
              'addClass',
              'removeClass',
              'removeClasses',
              'toggleClass'
            ];

            fnNames.forEach(patchAnimations);
        },

        _filterByAnimationEffect: function(el, animationClass) {
            return _animationConfig.animationsMap[animationClass].filter(function(effect) {
                var animationClassFilter = ANIMATION_EFFECT_FILTERS[effect];
                return !(animationClassFilter && !animationClassFilter(el));
            });
        },

        _filterByExclusionClass: function(el, animationClass) {
            var exclusionClass = _animationsExclusionClasses[animationClass];

            // HACK: exclude elements with 'exclusion' classes
            if (_.isArray(exclusionClass)) {
                return Boolean(_.find(exclusionClass, function(cls) {
                    return el.classList.contains(cls);
                }));
            } else if (exclusionClass && el.classList.contains(exclusionClass)) {
                return true;
            }

            return false;
        },

        attachAnimation: function(event) {
            if (!_animatedElsSelector.length) {
                return;
            }
            var animatedEls = event.data.find(_animatedElsSelector);
            if (!animatedEls.length) {
                return;
            }

            var elAnimationsMap = [];

            animatedEls.forEach(function(el) {
                if ($.isWidgetAttached(el, 'animation')) {
                    return;
                }

                var elAnimations = {
                    el: el,
                    animations: []
                };

                _animatedClasses.forEach(function(animationClass) {
                    if (el.classList.contains(animationClass)) {
                        var isExcluded = this._filterByExclusionClass(el, animationClass);
                        var animations = this._filterByAnimationEffect(el, animationClass);

                        if (isExcluded || !animations.length) {
                            return;
                        }

                        elAnimations.animations = elAnimations.animations.concat(animations);
                    }
                }.bind(this));

                if (elAnimations.animations.length) {
                    elAnimationsMap.push(elAnimations);
                }
            }.bind(this));

            elAnimationsMap.forEach(function(elAnimations) {
                $(elAnimations.el).animation(elAnimations.animations);
            });

        }

    }, Backbone.Events);
});
